module.exports = __webpack_public_path__ + "static/media/selec-nft-2.cf2e71d4.png";